import { Common } from "@secondcloset/types";

export enum OrderOrchestrationCountryKeys {
  CA = "Canada",
  US = "United States of America",
  OTHER = "All Other Country",
}

export type FulfilledFromState = Record<
  keyof typeof OrderOrchestrationCountryKeys,
  {
    id?: string;
    country_code?: Common.Region["country_code"];
    country_name?: Common.Region["country_name"];
    facility?: Common.Facility<"V2">["name"];
  }
>;

export const fallbackFulfilledFromMapping = Object.entries(OrderOrchestrationCountryKeys).reduce(
  (acc, [key, value]) => ({
    ...acc,
    [key as keyof typeof OrderOrchestrationCountryKeys]: {
      country_code: key !== OrderOrchestrationCountryKeys.OTHER ? key : undefined,
      country_name: key !== OrderOrchestrationCountryKeys.OTHER ? value : undefined,
      facility: "unknown",
    },
  }),
  {} as FulfilledFromState
);

export const getFulfilledFrom = (defaultFulfilledFrom: Common.Organization["default_fulfilled_from"]) => {
  const defaultFulfilledFromMapping = defaultFulfilledFrom?.reduce(
    (acc, { organization_regions, facility }) => ({
      ...acc,
      [organization_regions.country_code || "OTHER"]: {
        id: organization_regions.id,
        country_code: organization_regions.country_code,
        country_name: organization_regions.country_name,
        facility: facility.name,
      },
    }),
    {} as FulfilledFromState
  );

  return { ...fallbackFulfilledFromMapping, ...defaultFulfilledFromMapping };
};
